module.exports = __webpack_public_path__ + "img/71a47b5.png";